const helpers = {
  loadScript(
    src: string,
    attributes: { [key: string]: string } = {},
    force = false
  ) {
    if (!src) {
      return Promise.reject(new Error('Script source is required'));
    }
    return new Promise((resolve, reject) => {
      const existingEl = document.querySelector(`script[src="${src}"]`);

      if (existingEl && !force) {
        if (existingEl.classList.contains('is-loading')) {
          const onLoad = () => {
            existingEl.removeEventListener('load', onLoad);
            existingEl.removeEventListener('error', onError);
            existingEl.removeEventListener('abort', onAbort);
            resolve(true);
          };
          const onError = (event: Event) => {
            existingEl.removeEventListener('load', onLoad);
            existingEl.removeEventListener('error', onError);
            existingEl.removeEventListener('abort', onAbort);
            console.error('Script loading error:', event, 'for src:', src);
            reject(new Error(`Failed to load script: ${src}`));
          };
          const onAbort = (event: Event) => {
            existingEl.removeEventListener('load', onLoad);
            existingEl.removeEventListener('error', onError);
            existingEl.removeEventListener('abort', onAbort);
            console.warn('Script loading aborted:', event, 'for src:', src);
            reject(new Error(`Script loading aborted: ${src}`));
          };

          existingEl.addEventListener('load', onLoad);
          existingEl.addEventListener('error', onError);
          existingEl.addEventListener('abort', onAbort);
        } else {
          resolve(true);
        }
      } else {
        const el = document.createElement('script');

        el.type = 'text/javascript';
        el.defer = true;
        el.src = src;
        el.classList.add('is-loading');

        for (const key in attributes) {
          el.setAttribute(key, attributes[key]);
        }

        el.addEventListener('load', () => {
          el.classList.remove('is-loading');
          resolve(true);
        });

        el.addEventListener('error', (event) => {
          el.classList.remove('is-loading');
          console.error('Script loading error:', event, 'for src:', src);
          reject(new Error(`Failed to load script: ${src}`));
        });

        el.addEventListener('abort', (event) => {
          el.classList.remove('is-loading');
          console.warn('Script loading aborted:', event, 'for src:', src);
          reject(new Error(`Script loading aborted: ${src}`));
        });

        document.head.appendChild(el);
      }
    });
  },
};

export default Object.freeze(helpers);
